import {WarningTextDefaultBox} from "./warning-text.default.box";

export const WarningTextBox = WarningTextDefaultBox;